export default __webpack_public_path__ + "static/media/ubaform-logo.44e11ce6.svg";